export function createHereCrud() {
  type Header = {
    Geolocation: string
  }
  const headers = {} as Header
  navigator.geolocation.getCurrentPosition(function (position) {
    headers.Geolocation =
      position.coords.latitude + ',' + position.coords.longitude
  })
  /*eslint-disable */
  // @ts-ignore
  const platform = new window.H.service.Platform({
    apikey: process.env.REACT_HERE_API_KEY!,
  })
  /*eslint-disable */
  // @ts-ignore
  const places = platform.getSearchService()

  const getAddressDetail = function (placeResult) {
    const location = placeResult.location

    if (!location) return null

    return {
      lineOne: [location.address.house, location.address.street]
        .filter(Boolean)
        .join(' '),
      lineTwo: null,
      city: getCity(location),
      state: location.address.state,
      stateAbbreviation: location.address.stateCode,
      postalCode: location.address.postalCode,
      county: location.address.county,
      country: location.address.country,
      latitude: location.position[0],
      longitude: location.position[1],
    }
  }

  function getCity(location) {
    let city = ''

    if (location.address.country == 'Australia') {
      city = location.address.district
    } else {
      city = location.address.city
    }

    return city
  }

  const getPlaceAddress = function (place, callback) {
    place.follow(
      function (details) {
        callback(getAddressDetail(details), null)
      },
      function () {},
    )
  }

  const queryPlaces = function (
    input,
    geocodeString,
    callback,
    localizationEnabled,
  ) {
    if (!input || !callback) return
    if (
      !headers.Geolocation ||
      (headers.Geolocation && headers.Geolocation.toString().trim() == '')
    ) {
      headers.Geolocation = geocodeString
      if (geocodeString.length == 0)
        headers.Geolocation = '45.83985500000001,-119.70058339999999'
    }

    places.discover(
      {
        at: headers.Geolocation,
        limit: 5,
        q: input,
        in: `countryCode:USA${localizationEnabled ? ',CAN' : ''}`,
        mapview: '1',
      },
      function (response: { items: HereResult[] }) {
        const houseNumberMatch = response.items.find(
          (item) => item.resultType === 'houseNumber',
        )
        const results = houseNumberMatch
          ? [
              houseNumberMatch,
              ...response.items.filter(
                (item) => item.id !== houseNumberMatch.id,
              ),
            ]
          : response.items
        callback(results)
      },
      console.error,
    )
  }

  const geocode = function (
    input: string,
    at: string,
    callback: (results?: HereResult[]) => void,
  ) {
    if (input.length < 2 || !callback) return

    if (
      !headers.Geolocation ||
      (headers.Geolocation && headers.Geolocation.toString().trim() == '')
    ) {
      headers.Geolocation = at
      if (at.length == 0)
        headers.Geolocation = '45.83985500000001,-119.70058339999999'
    }

    places.geocode(
      { at: headers.Geolocation, q: input, mapview: '1' },
      (response: { items: HereResult[] }) => {
        const houseNumberMatches = response?.items
          ? response.items.filter((item) => item.resultType === 'houseNumber')
          : []

        callback(houseNumberMatches)
      },
      console.error,
    )
  }

  return {
    getPlaceAddress,
    queryPlaces,
    geocode,
  }
}

export interface HereResult {
  title: string
  id: string
  language?: string
  localityType?: string
  administrativeAreaType?: string
  resultType: string
  address: {
    label: string
    countryCode: string
    countryName: string
    stateCode: string
    state: string
    county: string
    city: string
    district: string
    street?: string
    postalCode: string
    houseNumber?: string
  }
  position: {
    lat: number
    lng: number
  }
  mapView: {
    north: number
    south: number
    east: number
    west: number
  }
}
